import React, { useState } from 'react';
import { Button, Grid, Typography, Container, Box } from '@material-ui/core';
import Layout from '../Layout';
import { useDispatch } from 'react-redux';
import CustomBreadcrumbs from '../Breadcrumb';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getITMSData, getSAPData } from '../../ReduxStore/MastertableSlice';
import * as XLSX from 'xlsx';
import ExportProgressModal from '../ExportProgressModal';




const DownloadData = () => {
    const dispatch = useDispatch();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: 'Settings', href: '/settings' },
        { label: 'Data Management', href: '/data-management' }
    ];

    const [exportLoading, setExportLoading] = useState(false);
    const [progress, setProgress] = useState();

    // Function to export data to Excel
    const downloadSapData = async () => {
        let page = 0;
        const limit = 10000; // Page size
        let allData = []; // Array to store all fetched data
        let totalPages = 1; // Initialize total pages

        setExportLoading(true); // Show the modal
        setProgress(0); // Reset progress

        try {
            do {
                // Fetch paginated data
                const action = dispatch(getSAPData({ page: page + 1, limit }));
                const res = await action.unwrap();

                if (res.result) {
                    const { data, total_rows, total_pages } = res.result;

                    // Aggregate data
                    allData = [...allData, ...data];

                    // Set total pages and total rows on the first fetch
                    if (page === 0) {
                        totalPages = total_pages;
                    }

                    // Calculate progress percentage
                    const percentage = Math.min(((page + 1) / totalPages) * 100, 100);
                    setProgress(percentage); // Update progress bar

                    // Process each page data if necessary
                    console.log(`Fetched page ${page + 1} of ${totalPages}`);

                    // Increment page number
                    page++;
                } else {
                    throw new Error("Failed to fetch data from the API");
                }
            } while (page < totalPages); // Continue until all pages are fetched

            // Modify the data (e.g., remove first 3 characters from asset_no)
            const modifiedData = allData.map(item => ({
                ...item,
                asset_no: item.asset_no ? item.asset_no.slice(3) : item.asset_no
            }));
            // Create a worksheet from the aggregated and modified data
            const worksheet = XLSX.utils.json_to_sheet(modifiedData);

            // Create a new workbook and append the worksheet
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

            // Generate a buffer and trigger the download
            XLSX.writeFile(workbook, 'SAP.xlsx');

            toast.success("SAP Downloaded successfully!");
            setExportLoading(false)
        } catch (error) {
            console.error("Error while exporting data:", error);
            toast.error(error.message || "Something went wrong while exporting!");
        } finally {
            setExportLoading(false); // Hide the modal
            setProgress(0); // Reset progress
        }
    };
    // Function to export data to Excel
    const downloadITMSData = async () => {
        let page = 0;
        const limit = 10000; // Page size
        let allData = []; // Array to store all fetched data
        let totalPages = 1; // Initialize total pages

        setExportLoading(true); // Show the modal
        setProgress(0); // Reset progress

        try {
            do {
                // Fetch paginated data
                const action = dispatch(getITMSData({ page: page + 1, limit }));
                const res = await action.unwrap();
                if (res.result) {
                    const { data, total_rows, total_pages } = res.result;

                    // Aggregate data
                    allData = [...allData, ...data];

                    // Set total pages and total rows on the first fetch
                    if (page === 0) {
                        totalPages = total_pages;
                    }

                    // Calculate progress percentage
                    const percentage = Math.min(((page + 1) / totalPages) * 100, 100);
                    setProgress(percentage); // Update progress bar

                    // Process each page data if necessary
                    console.log(`Fetched page ${page + 1} of ${totalPages}`);

                    // Increment page number
                    page++;
                } else {
                    throw new Error("Failed to fetch data from the API");
                }
            } while (page < totalPages); // Continue until all pages are fetched

            // Modify the data (e.g., remove first 3 characters from asset_no)
            const modifiedData = allData.map(item => ({
                ...item,
                asset_code_no: item.asset_code_no ? item.asset_code_no.slice(3) : item.asset_code_no
            }));
            // Create a worksheet from the aggregated and modified data
            const worksheet = XLSX.utils.json_to_sheet(modifiedData);

            // Create a new workbook and append the worksheet
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

            // Generate a buffer and trigger the download
            XLSX.writeFile(workbook, 'ITMS.xlsx');

            toast.success("ITMS Downloaded successfully!");
            setExportLoading(false)
        } catch (error) {
            console.error("Error while exporting data:", error);
            toast.error(error.message || "Something went wrong while exporting!");
        } finally {
            setExportLoading(false); // Hide the modal
            setProgress(0); // Reset progress
        }
    };

    return (
        <Layout>
            <Container>
                <ExportProgressModal open={exportLoading} progress={progress} />
                <Box mt={1} mb={3}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Download Data" />
                </Box>
                <Box mb={6}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                            <Typography variant="h6" gutterBottom>
                                Download SAP Data
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <Button variant="contained" component="span" color="primary" onClick={downloadSapData} style={{ backgroundColor: "green" }} >
                                Download SAP File
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
                <Box mb={6}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                            <Typography variant="h6" gutterBottom>
                                Download ITMS Data
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <Button variant="contained" component="span" color="primary" onClick={downloadITMSData} style={{ backgroundColor: "green" }}>
                                Download ITMS File
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Container>
            <ToastContainer />
        </Layout>
    );
};

export default DownloadData;
